import React from "react";
import classNames from "classnames";

const TextBlock = (props) => {
  const spanClassname = classNames([
    "block text-left graphikFont",
    props.big === true ? "text-2xl" : ""
  ]);

  return (
    <span className={spanClassname} style={props.customStyle}>
      {props.content}
    </span>
  );
};

export default TextBlock;
